import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';

import { SfoAdmonitionComponent } from '../widgets';
import { DrawerViewModule } from './drawer-view';
import { DynamicFormComponent } from './dynamic-form.component';
import { DynamicFieldModule } from './form-fields';
import { SfoFormHelperService } from './form-helper.class';
import { QuickSettingsModule } from './quicksettings-view';
import { SimpleViewComponent } from './simple-view/simple-view.component';
import { TabViewComponent } from './tab-view/tab-view.component';

@NgModule({
  declarations: [DynamicFormComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatDatepickerModule,
    MatExpansionModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatRadioModule,
    MatSelectModule,
    MatSidenavModule,
    MatSlideToggleModule,
    MatTabsModule,
    MatTooltipModule,
    SimpleViewComponent,
    TabViewComponent,
    DynamicFieldModule,
    DrawerViewModule,
    QuickSettingsModule,
    SfoAdmonitionComponent,
  ],
  exports: [DynamicFormComponent],
  providers: [
    {
      // The single control point for how every field this engine renders looks.
      // It used to be dead: each input template hardcoded `appearance`, which
      // overrides the token, so this value was never consulted. The hardcodes
      // are gone, so a consumer can now override the appearance for its own
      // subtree by providing this token on its component — no plumbing.
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: { appearance: 'fill' },
    },
    SfoFormHelperService,
  ],
})
export class SfoDynamicFormModule {}
